import {
  ConsumirRegistro,
  ConsumirLogin,
  ConsumirCerrarSession,
  ConsumirCambioClave,
  ActualizarCliente,
  Cargando,
  Error,
} from "./../Types/Login.type";

const INITIAL_STATE = {
  Cliente: {},
  Resultado: "",
  Mensaje: "",
  Cargando: false,
  hayCliente: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActualizarCliente:
      return {
        ...state,
        Cliente: action.payload[0] || {},
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
        hayCliente: true,
      };
    case ConsumirRegistro:
      return {
        ...state,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
        hayCliente: false,
      };
    case ConsumirLogin:
      return {
        ...state,
        Cliente: action.payload[0] || {},
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
        hayCliente: action.Resultado !== "S" ? false : true,
      };
    case ConsumirCerrarSession:
      return {
        ...state,
        Cliente: action.payload,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
        hayCliente: false,
      };
    case ConsumirCambioClave:
      return {
        ...state,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case Cargando:
      return {
        ...state,
        Resultado: "",
        Mensaje: "",
        Cargando: true,
      };
    case Error:
      return {
        ...state,
        Resultado: "E",
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    default:
      return state;
  }
};
